module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30477",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4984",
      "atom": "static-1.5350",
      "client-types": "static-1.496",
      "conversations-error-reporting": "static-1.9156",
      "conversations-internal-pub-sub": "static-1.16252",
      "conversations-internal-schema": "static-1.13353",
      "conversations-message-history": "static-1.13488",
      "conversations-test-sdk": "static-1.10769",
      "conversations-visitor-experience-components": "static-1.23840",
      "data-fetching-client": "static-1.9924",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5861",
      "hs-test-utils": "static-1.8294",
      "hubspot-dlb": "static-2.1882",
      "HubStyleTokens": "static-2.11749",
      "I18n": "static-7.1666",
      "immer": "static-1.94",
      "jasmine-immutable": "static-1.3287",
      "jasmine-runner": "static-1.6718",
      "quartz": "static-1.7409",
      "react-dlb": "static-1.88",
      "react-select-plus": "static-1.109",
      "react-transition-group": "static-2.69",
      "redux-thunk": "static-2.77",
      "reselect": "static-3.9",
      "sanitize": "static-1.4739",
      "StyleGuideUI": "static-3.498",
      "transmute": "static-2.85",
      "urlinator": "static-1.4798",
      "usage-tracker": "static-1.7621",
      "usage-tracker-core": "static-1.7471",
      "usage-tracker-public": "static-1.7432",
      "viral-links-lib": "static-1.7340",
      "visitor-ui-component-library": "static-1.6417",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5073",
      "conversations-prop-types": "static-1.7722",
      "conversations-visitor-message-history": "static-1.22577",
      "cssUtils": "static-1.883",
      "enviro": "static-4.455",
      "flux-actions": "static-1.363",
      "foundations-components": "static-1.8433",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6478",
      "interactive-cards": "static-1.324",
      "hubspot-url-utils": "static-1.4297",
      "immutable": "static-2.83",
      "metrics-js": "static-1.9867",
      "PatternValidationJS": "static-1.3160",
      "PortalIdParser": "static-2.404",
      "pulse": "static-1.892",
      "raven": "static-3.5925",
      "react": "static-7.192",
      "react-aria": "static-1.70",
      "react-dom": "static-7.85",
      "react-redux": "static-7.75",
      "react-rhumb": "static-1.16981",
      "react-utils": "static-2.5533",
      "redux": "static-4.76",
      "rpc-client-utils": "static-1.4929",
      "redux-toolkit": "static-1.75",
      "sanitize-text": "static-1.8418",
      "signup-constants": "static-1.19548",
      "styled-components": "static-2.95",
      "usage-tracker-multi": "static-1.6035",
      "visitor-ui-component-library-icons": "static-1.6228",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3593",
      "moment": "static-3.26",
      "quartz-config": "static-1.1187",
      "quartz-core": "static-1.6628",
      "foundations-assets": "static-1.5147",
      "foundations-theming": "static-1.4734",
      "UIComponents": "static-3.8695",
      "conversations-async-data": "static-2.7934",
      "customer-data-email": "static-1.18477",
      "cv-backend-services": "static-1.1590",
      "immutable-less": "static-1.4916",
      "conversations-skeleton-state": "static-1.7512",
      "crm-events-viz-core": "static-1.33964",
      "customer-data-objects": "static-1.7952",
      "icons": "static-2.677",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.820",
      "ui-images": "static-2.1237",
      "apollo-stack-hubspot": "static-3.91",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.86",
      "HeadJS": "static-2.792",
      "framer-motion": "static-1.76",
      "hs-test-utils-bend-plugin": "static-1.3405",
      "msw": "static-1.39",
      "testing-library": "static-1.156",
      "i18n-data": "static-1.228",
      "moment-timezone": "static-5.87",
      "jasmine": "static-4.4579",
      "signup-ui-url-generator": "static-2.8326",
      "HubStyle": "static-2.12056",
      "quartz-i18n": "static-1.1084",
      "sassPrefix": "static-1.163",
      "bend-plugin-foundations-components": "static-1.4702",
      "floating-ui": "static-1.62",
      "foundations-theming-specialty": "static-1.2450",
      "hs-story-utils": "static-1.9691",
      "react-create-root-preference": "static-1.66",
      "react-virtualized": "static-2.104",
      "tanstack-table": "static-1.59",
      "trellis-assets": "static-1.2539",
      "ui-fonts": "static-1.1011",
      "hs-locale-management": "static-1.269",
      "bend-plugin-pulse": "static-1.395",
      "batch-promise": "static-1.1808",
      "chirp-fetch": "static-1.2159",
      "event-emitter": "static-1.1219",
      "fast-json-patch": "static-1.67",
      "hub-http-janus": "static-1.872",
      "quick-fetch": "static-1.4108",
      "csstype": "static-1.50",
      "quartz-head": "static-1.1074",
      "web-vitals": "static-1.11",
      "bend-plugin-chirp-manifest": "static-1.339",
      "quartz-routing": "static-1.839",
      "usage-tracker-anonymous": "static-1.6038",
      "bender-build-tools": "static-1.3409",
      "opentelemetry-fe-types": "static-1.34",
      "dispatcher": "static-1.142",
      "general-store": "static-6.20",
      "hubspotter-http": "static-1.4841",
      "mobile-manifest-mixins": "static-1.572",
      "module-federation": "static-1.30",
      "opentelemetry-fe": "static-1.409",
      "quartz-auth": "static-1.1084",
      "quartz-test": "static-1.1084",
      "quartz-tracking": "static-1.788",
      "trellis-components": "static-1.2558",
      "usage-tracker-container": "static-1.7611",
      "bend-plugin-foundations-theming": "static-1.3217",
      "foundations-theming-base": "static-1.3719",
      "stylex": "static-1.38",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4921",
      "customer-data-ui-utilities": "static-1.10094",
      "FileManagerCore": "static-1.39908",
      "FileManagerLib": "static-1.40049",
      "hubspot-apollo-client": "static-1.5144",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.532",
      "timezone-utils": "static-2.5509",
      "ui-gdpr-components": "static-1.10621",
      "ts-schema": "static-1.4270",
      "ai-components-ui-library": "static-1.9641",
      "avatar-components": "static-1.2759",
      "content-assistance-lib": "static-1.8156",
      "crm-component-utils": "static-1.39771",
      "crm-display-components": "static-1.25521",
      "crm-fe-perf": "static-1.23167",
      "crm-links": "static-1.6594",
      "crm-message-bus": "static-1.43684",
      "crm-search-service-types": "static-1.1419",
      "crm-source-interpretation-lib": "static-1.5595",
      "customer-data-communicator": "static-1.46261",
      "customer-data-filters-ui": "static-1.40808",
      "customer-data-objects-ui-components": "static-1.13295",
      "customer-data-properties": "static-1.52487",
      "customer-data-rte": "static-1.33593",
      "draft-plugins": "static-2.22110",
      "file-manager-components": "static-1.24409",
      "trellis-theming": "static-1.1232",
      "framework-data-schema-resolvers": "static-1.7158",
      "frontend-preferences-client": "static-1.8190",
      "hubspot-prosemirror": "static-1.18910",
      "object-comments-thread-lib": "static-1.11296",
      "prosemirror-user-and-team-at-mentions": "static-1.1146",
      "reference-resolvers-lite": "static-1.8367",
      "ui-addon-upgrades": "static-9.18339",
      "universal-associations-select": "static-1.11336",
      "universal-record-utils-lib": "static-1.1795",
      "wootric-nps": "static-1.7176",
      "inbound-db-properties-service-client": "static-1.4033",
      "property-translator": "static-1.5663",
      "segments-query-core": "static-1.1689",
      "opentelemetry-web": "static-1.11",
      "hub-http-shared-msw-handlers": "static-1.10562",
      "hubspotter-http-shared-msw-handlers": "static-1.10560",
      "usage-tracker-session-replay": "static-1.5307",
      "base-ui": "static-1.19",
      "react-day-picker": "static-1.7",
      "tanstack-virtual": "static-1.36",
      "react-dnd-compat": "static-1.4882",
      "breeze-artifacts-sdk": "static-1.242",
      "audio-components": "static-1.6296",
      "ContentUtils": "static-1.69065",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29762",
      "FileManagerImages": "static-1.37560",
      "foundations-components-legacy": "static-1.1458",
      "html-to-image": "static-1.58",
      "immerable": "static-1.4416",
      "react-colorpicker": "static-2.10473",
      "ui-universal-auth": "static-1.9335",
      "video-components": "static-1.14097",
      "video-data-lib": "static-1.35753",
      "video-embed": "static-1.36587",
      "hubspot-apollo-cache": "static-1.603",
      "chatspot-core": "static-1.22762",
      "copilot-toolkit": "static-1.11785",
      "superstore": "static-1.5023",
      "ui-addon-video-player": "static-1.8968",
      "ui-coaching-tips": "static-1.29250",
      "card-properties-lib": "static-1.44943",
      "commerce-subscription-lib": "static-1.37718",
      "crm-actions": "static-1.6615",
      "crm-cards-sdk": "static-1.44457",
      "customer-data-properties-shared-msw-handlers": "static-1.9889",
      "customer-data-property-utils": "static-1.8366",
      "customer-data-tracking": "static-1.7146",
      "hs-resources": "static-1.455",
      "inbound-db-meta-service-client": "static-1.3718",
      "framework-data-table": "static-2.12489",
      "location-customization-utils-lib": "static-1.10031",
      "restore-request-side-panel-lib": "static-1.1605",
      "calling-error-reporting": "static-1.31590",
      "calling-internal-common": "static-1.31583",
      "calling-usage-tracker": "static-1.6802",
      "crm_data": "static-4.92761",
      "customer-data-content": "static-1.27758",
      "draft-content-plugins": "static-1.28855",
      "draft-convert": "static-2.77",
      "draft-extend": "static-3.80",
      "draft-js": "static-5.82",
      "draft-signature-plugin": "static-1.24662",
      "EmailSignatureEditor": "static-1.24948",
      "hubspot-prosemirror-plugins": "static-1.18902",
      "integration-settings-components": "static-1.16146",
      "integrations-lib": "static-1.16969",
      "integrations-tracking-lib": "static-1.5872",
      "native-integrations-shared-strings": "static-1.8044",
      "nav-meta": "static-1.30391",
      "onboarding-scopes": "static-1.6718",
      "outreach-assistant-email-generation": "static-1.6766",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12268",
      "quotes-client-types": "static-1.38861",
      "reference-resolvers": "static-1.8447",
      "rich-text-lib": "static-1.20259",
      "sales-email-signature-service-client": "static-1.4110",
      "sequences-lib": "static-1.8489",
      "ui-addon-i18n": "static-1.11410",
      "ui-addon-iframeable": "static-1.9339",
      "ui-business-units-lib": "static-1.9350",
      "ui-shepherd-react": "static-3.10532",
      "user-context": "static-1.5382",
      "whatsapp-sending-lib": "static-1.6694",
      "customer-data-filters-ui-msw-helpers": "static-1.23243",
      "customer-data-reference-ui-components": "static-1.13444",
      "events-data-lib": "static-1.507",
      "FormUrlGenerator": "static-2.4992",
      "framework-builder-read-service-client": "static-1.4198",
      "multi-account-reference-resolvers": "static-1.1264",
      "onboarding-tours": "static-1.17068",
      "reporting-datasets-permissions-lib": "static-1.14404",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21871",
      "calling-global-api": "static-1.65471",
      "calling-lifecycle-internal": "static-1.66853",
      "calling-lifecycle-messages": "static-1.59147",
      "commerce-products-lib": "static-1.10459",
      "conditional-properties-service-client": "static-1.3988",
      "crm-index-visualization-core": "static-1.4499",
      "crm-pipelines-api-client-types": "static-1.4324",
      "external-options-client-types": "static-1.4316",
      "formula-editor": "static-1.14701",
      "google-libphonenumber": "static-1.42",
      "inbounddb-objects-service-types": "static-1.4402",
      "meetings-icalendar-utils-lib": "static-1.901",
      "multi-currency-client-types": "static-1.3885",
      "object-builder-ui-client": "static-1.49592",
      "pipeline-validation-client-types": "static-1.4159",
      "property-value-citations": "static-1.3101",
      "smart-data-capture-core": "static-1.67",
      "smart-property-lib": "static-1.8220",
      "tiered-pricing": "static-1.1903",
      "topics-actions-lib": "static-1.429",
      "trial-components-library": "static-1.14055",
      "ui-addon-form-validation": "static-1.11248",
      "zustand": "static-1.79",
      "breeze-engine-lib": "static-1.1623",
      "video-components-external": "static-1.12095",
      "fdsr-migration-layer": "static-1.277",
      "framework-data-schema-quick-fetch": "static-1.7063",
      "persist-promise": "static-1.3965",
      "content-media-capture": "static-1.5368",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.26114",
      "knowledge-content-types": "static-1.8632",
      "payment-link-components": "static-1.24108",
      "ui-addon-emoji-picker": "static-1.10151",
      "call-summary": "static-1.40161",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10708",
      "laboratory-lib": "static-3.7417",
      "merchandise-lib": "static-1.275",
      "purchase-motions-components": "static-1.6306",
      "crm-object-search-query-utilities": "static-1.10145",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "cms-field-types": "static-1.5079",
      "content-icons-ui": "static-1.2328",
      "underscore": "static-1.8",
      "unified-auth-core-lib": "static-1.1131",
      "social-insights-client-types": "static-1.22685",
      "outpost": "static-1.4423",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5731",
      "magpie-types": "static-1.5191",
      "simple-logging-lib": "static-1.3315",
      "growth-onboarding-feedback-components": "static-1.6849",
      "customer-data-sidebar": "static-2.46679",
      "enrichment-lib": "static-1.235",
      "ui-addon-draggable-compat": "static-2.4528",
      "commerce-billing-lib": "static-1.20073",
      "commerce-shared-components-lib": "static-1.19162",
      "commerce-tools-ui-lib": "static-1.10989",
      "customer-data-associations": "static-1.7592",
      "tasks-actions-lib": "static-1.59",
      "reporting-data": "static-1.68679",
      "ui-addon-draggable": "static-3.5022",
      "crm-record-cards-service-types": "static-1.3761",
      "crm_universal": "static-1.22451",
      "SalesContentIndexUI": "static-3.9587",
      "content-embed-lib": "static-1.7603",
      "data-model-builder-lib": "static-1.13068",
      "remote-dom": "static-1.2",
      "remote-ui": "static-1.70",
      "ui-components-test-utils": "static-1.5886",
      "ui-extensions-remote-renderer": "static-1.17813",
      "universal-page-editor-lib": "static-1.3271",
      "integrations-error-boundary-lib": "static-1.14384",
      "redux-observable": "static-1.72",
      "ReduxMessenger": "static-2.10635",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.849",
      "messaging-types-lib": "static-1.46809",
      "ai-addon-copilot-preview": "static-1.8853",
      "copilot-plugins": "static-1.11757",
      "data-token-picker": "static-1.16840",
      "sequences-client-types-lib": "static-1.8346",
      "foundations-components-test-utils": "static-1.5916",
      "navigation-messaging": "static-1.8081",
      "getting-started-shared-tasks": "static-1.19165",
      "getting-started-shared-tasks-store": "static-1.18283",
      "onboarding-tours-utils": "static-1.1134",
      "messaging-usage-based-billing-components-lib": "static-1.1934",
      "whatsapp-management-lib": "static-1.9853",
      "growth-data-modal": "static-1.5848",
      "growth-onboarding-confetti": "static-1.3328",
      "growth-onboarding-next-action-utils": "static-1.2633",
      "navigation-components": "static-1.18754",
      "onboarding-tours-client": "static-1.5282",
      "ui-shepherd-tracker": "static-1.7913",
      "shared-worker-versioning": "static-1.11306",
      "voice-sms-access-library": "static-1.1956",
      "commerce-permissions": "static-1.1042",
      "products-iframe-lib": "static-1.8531",
      "products-ui-components-shared-msw-handlers": "static-1.10944",
      "crm-index-associations-lib": "static-1.6706",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10645",
      "sales-views-client-types": "static-1.4520",
      "bark-lib": "static-1.16774",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.99",
      "crm-properties-common-lib": "static-1.6154",
      "react-codemirror": "static-1.10903",
      "data-agent-kit": "static-1.599",
      "fsm": "static-1.4009",
      "policy-lib": "static-1.7062",
      "embedded-academy-lib": "static-1.15432",
      "hubs-service-types": "static-1.1522",
      "purchase-motions-api": "static-1.6309",
      "breeze-engine-chat-components": "static-1.601",
      "breeze-engine-core": "static-1.901",
      "highlight.js": "static-1.83",
      "content-media-composition-data-lib": "static-1.13172",
      "content-media-compositions": "static-2.17179",
      "idb-keyval": "static-1.48",
      "media-bridge-lib": "static-1.19360",
      "fix-webm-duration": "static-1.27",
      "notification-sounds": "static-1.4690",
      "seat-types-lib": "static-1.658",
      "ui-addon-opt": "static-4.8629",
      "commerce-tours-lib": "static-1.6564",
      "growth-onboarding-reliability": "static-1.5345",
      "sales-checkout-service-client": "static-1.3794",
      "calling-cross-tab-library": "static-1.19562",
      "calling-lifecycle-usage-tracker": "static-1.9346",
      "reactive-lib": "static-1.985",
      "card-payment-highlight-lib": "static-1.37911",
      "card-subscription-highlight-lib": "static-1.40141",
      "commerce-contract-lib": "static-1.13229",
      "invoices-highlight-card-lib": "static-1.55614",
      "orders-highlight-card-lib": "static-1.22130",
      "products-highlight-card-lib": "static-1.18742",
      "quotes-highlight-card-lib": "static-1.72771",
      "data-agent-utils": "static-1.297",
      "usage-based-billing-components-lib": "static-1.10110",
      "utility-belt": "static-1.2799",
      "payments-enrollment-embed-lib": "static-1.23740",
      "stripe-embedded-components": "static-1.7949",
      "growth-onboarding-empty-states": "static-1.6221",
      "InboxConnectUtils": "static-4.15494",
      "payments-post-enroll-local-storage-lib": "static-1.5372",
      "qrcode-generator": "static-1.73",
      "reporting-client-types": "static-1.2658",
      "react-flip-move": "static-1.75",
      "FireAlarmUi": "static-1.4695",
      "sales-templates-service-types-lib": "static-1.4361",
      "ui-asset-management-lib": "static-1.11361",
      "association-settings-lib": "static-1.10949",
      "collaboration-sidebar": "static-1.58650",
      "conditional-property-settings-components": "static-1.148",
      "conditional-property-settings-modal": "static-1.13059",
      "data-model-commons-lib": "static-1.13322",
      "ExportDialog": "static-6.10643",
      "final-form": "static-1.75",
      "nudge-client-utils": "static-1.3100",
      "object-definition-builder-lib": "static-1.7374",
      "property-management-iframe": "static-1.14055",
      "property-usages-lib": "static-1.5755",
      "reactflow": "static-1.68",
      "simple-data-table": "static-1.3473",
      "used-in-list-lib": "static-1.7229",
      "visual-association": "static-1.6156",
      "highcharts": "static-8.108",
      "reporting-visualizations": "static-1.60754",
      "ui-extensibility-client-types": "static-1.4183",
      "adobe-sign-auth-lib": "static-1.396",
      "ads-unified-auth-lib": "static-1.1179",
      "google-sheets-integration-lib": "static-1.968",
      "microsoft-drive-auth-lib": "static-1.66",
      "surveymonkey-integration-lib": "static-1.412",
      "slack-ui-library": "static-1.10663",
      "automation-platform-service-types": "static-1.2661",
      "ContentData": "static-1.69140",
      "email-portal-health-service-types": "static-1.1244",
      "marketing-email-service-types": "static-1.2075",
      "ai-rendering-library": "static-1.11039",
      "ai-settings-ui-library": "static-1.8277",
      "ui-brand-identity-lib": "static-1.16332",
      "messaging-shared-utils-lib": "static-1.1383",
      "messaging-user-info-utils-lib": "static-1.1553",
      "content-whatsapp-service-types": "static-1.560",
      "marketing-platform-lib": "static-1.7132",
      "short-messages-app-service-client": "static-1.4179",
      "ui-tool-access": "static-1.10418",
      "onboarding-data-sync-lib": "static-1.2445",
      "growth-onboarding-next-action-components": "static-1.2661",
      "user-context-client": "static-1.4775",
      "nest": "static-1.501",
      "calling-orchestration-schema": "static-1.36733",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16303",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4774",
      "storybook-react": "static-1.37",
      "academy-common-lib": "static-1.14892",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40977",
      "accounting-integrations-ui-components": "static-1.7490",
      "invoices-ui-lib": "static-1.55630",
      "commerce-products-api": "static-1.2652",
      "invoices-iframe-lib": "static-1.57688",
      "quotes-modal-lib": "static-1.103449",
      "quotes-ui-lib": "static-1.81492",
      "one-click-checkout": "static-1.331",
      "platform-infra-nav-components": "static-1.7868",
      "reporting-ui-components": "static-2.65949",
      "subscription-experience-data-types": "static-1.15218",
      "marketplace-ui-apps-core": "static-1.19178",
      "stripe-connect-js": "static-1.75",
      "ui-addon-react-router-dom": "static-1.9803",
      "hub-http-contrib": "static-1.3304",
      "ui-addon-sales-email": "static-1.5478",
      "nested-table": "static-1.498",
      "chatspot-widget-iframe": "static-1.22753",
      "collaboration-sidebar-common": "static-1.3447",
      "conditional-property-settings-data": "static-1.166",
      "nudge-custom-function-registry": "static-1.2857",
      "nudge-renderer-utils": "static-1.3176",
      "whisper-core-api": "static-1.7267",
      "property-management-common": "static-1.6343",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15532",
      "advanced-menus-lib": "static-1.12410",
      "ui-memberships-settings-lib": "static-1.34781",
      "breeze-onboarding-components": "static-1.656",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.41953",
      "reporting-snowflake": "static-1.57296",
      "upgrade-components-lib": "static-1.473",
      "meetings-connect-utils-lib": "static-1.7873",
      "academy-service-client": "static-1.3954",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4669",
      "trellis-ecosystem": "static-1.7584",
      "commerce-tax-lib": "static-1.802",
      "price-books-api": "static-1.1674",
      "price-books-components": "static-1.1732",
      "property-description-translator": "static-1.4106",
      "ramp-editor": "static-1.837",
      "commerce-analytics-service-client": "static-1.3782",
      "totals-ui-components": "static-1.24237",
      "checkout-sdk": "static-3.24269",
      "payment-method-components": "static-1.7113",
      "touchless-buying-components": "static-1.6137",
      "upgrade-catalog-service-types": "static-1.3747",
      "reporting-plugins": "static-1.10693",
      "reporting-reports": "static-1.68356",
      "edison-service-client-types": "static-1.657",
      "developer-experience-shared-components": "static-1.10768",
      "marketplace-ui-client-types": "static-1.18053",
      "marketplace-ui-common": "static-1.20646",
      "ui-addon-integrations-directory-panel": "static-2.8290",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.426",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15531",
      "simple-menus-lib": "static-1.17048",
      "onboarding-journeys-lib": "static-1.845",
      "dashboard-lib": "static-1.82702",
      "share-with-third-party-component-lib": "static-1.8970",
      "line-items-api": "static-1.1053",
      "commerce-totals-service-types": "static-1.4007",
      "hub-http-rxjs": "static-1.836",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4255",
      "company-details-components": "static-1.6467",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.15607",
      "quote-checkout-service-types": "static-1.3721",
      "campaign-roi-lib": "static-1.10060",
      "campaigns-utils-lib": "static-1.3468",
      "ui-addon-calendars": "static-2.5594",
      "apps-service-types": "static-1.4006",
      "oauth-service-types": "static-1.4507",
      "ui-product-approvals-common": "static-1.933",
      "redux-actions": "static-3.68",
      "company-details-service-types": "static-1.4203",
      "pricing-pages-api": "static-1.15472"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30477",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4984",
      "atom": "/atom/static-1.5350",
      "client-types": "/client-types/static-1.496",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9156",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16252",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13353",
      "conversations-message-history": "/conversations-message-history/static-1.13488",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10769",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.23840",
      "data-fetching-client": "/data-fetching-client/static-1.9924",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5861",
      "hs-test-utils": "/hs-test-utils/static-1.8294",
      "hubspot-dlb": "/hubspot-dlb/static-2.1882",
      "HubStyleTokens": "/HubStyleTokens/static-2.11749",
      "I18n": "/I18n/static-7.1666",
      "immer": "/immer/static-1.94",
      "jasmine-immutable": "/jasmine-immutable/static-1.3287",
      "jasmine-runner": "/jasmine-runner/static-1.6718",
      "quartz": "/quartz/static-1.7409",
      "react-dlb": "/react-dlb/static-1.88",
      "react-select-plus": "/react-select-plus/static-1.109",
      "react-transition-group": "/react-transition-group/static-2.69",
      "redux-thunk": "/redux-thunk/static-2.77",
      "reselect": "/reselect/static-3.9",
      "sanitize": "/sanitize/static-1.4739",
      "StyleGuideUI": "/StyleGuideUI/static-3.498",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4798",
      "usage-tracker": "/usage-tracker/static-1.7621",
      "usage-tracker-core": "/usage-tracker-core/static-1.7471",
      "usage-tracker-public": "/usage-tracker-public/static-1.7432",
      "viral-links-lib": "/viral-links-lib/static-1.7340",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6417",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5073",
      "conversations-prop-types": "/conversations-prop-types/static-1.7722",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22577",
      "cssUtils": "/cssUtils/static-1.883",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.363",
      "foundations-components": "/foundations-components/static-1.8433",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6478",
      "interactive-cards": "/interactive-cards/static-1.324",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
      "immutable": "/immutable/static-2.83",
      "metrics-js": "/metrics-js/static-1.9867",
      "PatternValidationJS": "/PatternValidationJS/static-1.3160",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "pulse": "/pulse/static-1.892",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.192",
      "react-aria": "/react-aria/static-1.70",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.75",
      "react-rhumb": "/react-rhumb/static-1.16981",
      "react-utils": "/react-utils/static-2.5533",
      "redux": "/redux/static-4.76",
      "rpc-client-utils": "/rpc-client-utils/static-1.4929",
      "redux-toolkit": "/redux-toolkit/static-1.75",
      "sanitize-text": "/sanitize-text/static-1.8418",
      "signup-constants": "/signup-constants/static-1.19548",
      "styled-components": "/styled-components/static-2.95",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6035",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6228",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3593",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.1187",
      "quartz-core": "/quartz-core/static-1.6628",
      "foundations-assets": "/foundations-assets/static-1.5147",
      "foundations-theming": "/foundations-theming/static-1.4734",
      "UIComponents": "/UIComponents/static-3.8695",
      "conversations-async-data": "/conversations-async-data/static-2.7934",
      "customer-data-email": "/customer-data-email/static-1.18477",
      "cv-backend-services": "/cv-backend-services/static-1.1590",
      "immutable-less": "/immutable-less/static-1.4916",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7512",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33964",
      "customer-data-objects": "/customer-data-objects/static-1.7952",
      "icons": "/icons/static-2.677",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.820",
      "ui-images": "/ui-images/static-2.1237",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.86",
      "HeadJS": "/HeadJS/static-2.792",
      "framer-motion": "/framer-motion/static-1.76",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3405",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.156",
      "i18n-data": "/i18n-data/static-1.228",
      "moment-timezone": "/moment-timezone/static-5.87",
      "jasmine": "/jasmine/static-4.4579",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8326",
      "HubStyle": "/HubStyle/static-2.12056",
      "quartz-i18n": "/quartz-i18n/static-1.1084",
      "sassPrefix": "/sassPrefix/static-1.163",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4702",
      "floating-ui": "/floating-ui/static-1.62",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2450",
      "hs-story-utils": "/hs-story-utils/static-1.9691",
      "react-create-root-preference": "/react-create-root-preference/static-1.66",
      "react-virtualized": "/react-virtualized/static-2.104",
      "tanstack-table": "/tanstack-table/static-1.59",
      "trellis-assets": "/trellis-assets/static-1.2539",
      "ui-fonts": "/ui-fonts/static-1.1011",
      "hs-locale-management": "/hs-locale-management/static-1.269",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.395",
      "batch-promise": "/batch-promise/static-1.1808",
      "chirp-fetch": "/chirp-fetch/static-1.2159",
      "event-emitter": "/event-emitter/static-1.1219",
      "fast-json-patch": "/fast-json-patch/static-1.67",
      "hub-http-janus": "/hub-http-janus/static-1.872",
      "quick-fetch": "/quick-fetch/static-1.4108",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.1074",
      "web-vitals": "/web-vitals/static-1.11",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.339",
      "quartz-routing": "/quartz-routing/static-1.839",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6038",
      "bender-build-tools": "/bender-build-tools/static-1.3409",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.34",
      "dispatcher": "/dispatcher/static-1.142",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http": "/hubspotter-http/static-1.4841",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.572",
      "module-federation": "/module-federation/static-1.30",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.409",
      "quartz-auth": "/quartz-auth/static-1.1084",
      "quartz-test": "/quartz-test/static-1.1084",
      "quartz-tracking": "/quartz-tracking/static-1.788",
      "trellis-components": "/trellis-components/static-1.2558",
      "usage-tracker-container": "/usage-tracker-container/static-1.7611",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3217",
      "foundations-theming-base": "/foundations-theming-base/static-1.3719",
      "stylex": "/stylex/static-1.38",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4921",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10094",
      "FileManagerCore": "/FileManagerCore/static-1.39908",
      "FileManagerLib": "/FileManagerLib/static-1.40049",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5144",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.532",
      "timezone-utils": "/timezone-utils/static-2.5509",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10621",
      "ts-schema": "/ts-schema/static-1.4270",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9641",
      "avatar-components": "/avatar-components/static-1.2759",
      "content-assistance-lib": "/content-assistance-lib/static-1.8156",
      "crm-component-utils": "/crm-component-utils/static-1.39771",
      "crm-display-components": "/crm-display-components/static-1.25521",
      "crm-fe-perf": "/crm-fe-perf/static-1.23167",
      "crm-links": "/crm-links/static-1.6594",
      "crm-message-bus": "/crm-message-bus/static-1.43684",
      "crm-search-service-types": "/crm-search-service-types/static-1.1419",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5595",
      "customer-data-communicator": "/customer-data-communicator/static-1.46261",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40808",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13295",
      "customer-data-properties": "/customer-data-properties/static-1.52487",
      "customer-data-rte": "/customer-data-rte/static-1.33593",
      "draft-plugins": "/draft-plugins/static-2.22110",
      "file-manager-components": "/file-manager-components/static-1.24409",
      "trellis-theming": "/trellis-theming/static-1.1232",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7158",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8190",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18910",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11296",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1146",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8367",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18339",
      "universal-associations-select": "/universal-associations-select/static-1.11336",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1795",
      "wootric-nps": "/wootric-nps/static-1.7176",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4033",
      "property-translator": "/property-translator/static-1.5663",
      "segments-query-core": "/segments-query-core/static-1.1689",
      "opentelemetry-web": "/opentelemetry-web/static-1.11",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10562",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10560",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5307",
      "base-ui": "/base-ui/static-1.19",
      "react-day-picker": "/react-day-picker/static-1.7",
      "tanstack-virtual": "/tanstack-virtual/static-1.36",
      "react-dnd-compat": "/react-dnd-compat/static-1.4882",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.242",
      "audio-components": "/audio-components/static-1.6296",
      "ContentUtils": "/ContentUtils/static-1.69065",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29762",
      "FileManagerImages": "/FileManagerImages/static-1.37560",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1458",
      "html-to-image": "/html-to-image/static-1.58",
      "immerable": "/immerable/static-1.4416",
      "react-colorpicker": "/react-colorpicker/static-2.10473",
      "ui-universal-auth": "/ui-universal-auth/static-1.9335",
      "video-components": "/video-components/static-1.14097",
      "video-data-lib": "/video-data-lib/static-1.35753",
      "video-embed": "/video-embed/static-1.36587",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.603",
      "chatspot-core": "/chatspot-core/static-1.22762",
      "copilot-toolkit": "/copilot-toolkit/static-1.11785",
      "superstore": "/superstore/static-1.5023",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8968",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29250",
      "card-properties-lib": "/card-properties-lib/static-1.44943",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37718",
      "crm-actions": "/crm-actions/static-1.6615",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44457",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9889",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8366",
      "customer-data-tracking": "/customer-data-tracking/static-1.7146",
      "hs-resources": "/hs-resources/static-1.455",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "framework-data-table": "/framework-data-table/static-2.12489",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10031",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1605",
      "calling-error-reporting": "/calling-error-reporting/static-1.31590",
      "calling-internal-common": "/calling-internal-common/static-1.31583",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6802",
      "crm_data": "/crm_data/static-4.92761",
      "customer-data-content": "/customer-data-content/static-1.27758",
      "draft-content-plugins": "/draft-content-plugins/static-1.28855",
      "draft-convert": "/draft-convert/static-2.77",
      "draft-extend": "/draft-extend/static-3.80",
      "draft-js": "/draft-js/static-5.82",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24662",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24948",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18902",
      "integration-settings-components": "/integration-settings-components/static-1.16146",
      "integrations-lib": "/integrations-lib/static-1.16969",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5872",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8044",
      "nav-meta": "/nav-meta/static-1.30391",
      "onboarding-scopes": "/onboarding-scopes/static-1.6718",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6766",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12268",
      "quotes-client-types": "/quotes-client-types/static-1.38861",
      "reference-resolvers": "/reference-resolvers/static-1.8447",
      "rich-text-lib": "/rich-text-lib/static-1.20259",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4110",
      "sequences-lib": "/sequences-lib/static-1.8489",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11410",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9339",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9350",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10532",
      "user-context": "/user-context/static-1.5382",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6694",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23243",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13444",
      "events-data-lib": "/events-data-lib/static-1.507",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4992",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4198",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1264",
      "onboarding-tours": "/onboarding-tours/static-1.17068",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14404",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21871",
      "calling-global-api": "/calling-global-api/static-1.65471",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66853",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59147",
      "commerce-products-lib": "/commerce-products-lib/static-1.10459",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3988",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4499",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4324",
      "external-options-client-types": "/external-options-client-types/static-1.4316",
      "formula-editor": "/formula-editor/static-1.14701",
      "google-libphonenumber": "/google-libphonenumber/static-1.42",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4402",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.901",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3885",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49592",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4159",
      "property-value-citations": "/property-value-citations/static-1.3101",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.67",
      "smart-property-lib": "/smart-property-lib/static-1.8220",
      "tiered-pricing": "/tiered-pricing/static-1.1903",
      "topics-actions-lib": "/topics-actions-lib/static-1.429",
      "trial-components-library": "/trial-components-library/static-1.14055",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11248",
      "zustand": "/zustand/static-1.79",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1623",
      "video-components-external": "/video-components-external/static-1.12095",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.277",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7063",
      "persist-promise": "/persist-promise/static-1.3965",
      "content-media-capture": "/content-media-capture/static-1.5368",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.26114",
      "knowledge-content-types": "/knowledge-content-types/static-1.8632",
      "payment-link-components": "/payment-link-components/static-1.24108",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10151",
      "call-summary": "/call-summary/static-1.40161",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10708",
      "laboratory-lib": "/laboratory-lib/static-3.7417",
      "merchandise-lib": "/merchandise-lib/static-1.275",
      "purchase-motions-components": "/purchase-motions-components/static-1.6306",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10145",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "cms-field-types": "/cms-field-types/static-1.5079",
      "content-icons-ui": "/content-icons-ui/static-1.2328",
      "underscore": "/underscore/static-1.8",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1131",
      "social-insights-client-types": "/social-insights-client-types/static-1.22685",
      "outpost": "/outpost/static-1.4423",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5731",
      "magpie-types": "/magpie-types/static-1.5191",
      "simple-logging-lib": "/simple-logging-lib/static-1.3315",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6849",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46679",
      "enrichment-lib": "/enrichment-lib/static-1.235",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4528",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20073",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19162",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10989",
      "customer-data-associations": "/customer-data-associations/static-1.7592",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.59",
      "reporting-data": "/reporting-data/static-1.68679",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.5022",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3761",
      "crm_universal": "/crm_universal/static-1.22451",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9587",
      "content-embed-lib": "/content-embed-lib/static-1.7603",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.13068",
      "remote-dom": "/remote-dom/static-1.2",
      "remote-ui": "/remote-ui/static-1.70",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5886",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17813",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3271",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14384",
      "redux-observable": "/redux-observable/static-1.72",
      "ReduxMessenger": "/ReduxMessenger/static-2.10635",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.849",
      "messaging-types-lib": "/messaging-types-lib/static-1.46809",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8853",
      "copilot-plugins": "/copilot-plugins/static-1.11757",
      "data-token-picker": "/data-token-picker/static-1.16840",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8346",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5916",
      "navigation-messaging": "/navigation-messaging/static-1.8081",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19165",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18283",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1134",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1934",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.9853",
      "growth-data-modal": "/growth-data-modal/static-1.5848",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3328",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2633",
      "navigation-components": "/navigation-components/static-1.18754",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5282",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7913",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11306",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1956",
      "commerce-permissions": "/commerce-permissions/static-1.1042",
      "products-iframe-lib": "/products-iframe-lib/static-1.8531",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10944",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6706",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10645",
      "sales-views-client-types": "/sales-views-client-types/static-1.4520",
      "bark-lib": "/bark-lib/static-1.16774",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.99",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6154",
      "react-codemirror": "/react-codemirror/static-1.10903",
      "data-agent-kit": "/data-agent-kit/static-1.599",
      "fsm": "/fsm/static-1.4009",
      "policy-lib": "/policy-lib/static-1.7062",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15432",
      "hubs-service-types": "/hubs-service-types/static-1.1522",
      "purchase-motions-api": "/purchase-motions-api/static-1.6309",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.601",
      "breeze-engine-core": "/breeze-engine-core/static-1.901",
      "highlight.js": "/highlight.js/static-1.83",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13172",
      "content-media-compositions": "/content-media-compositions/static-2.17179",
      "idb-keyval": "/idb-keyval/static-1.48",
      "media-bridge-lib": "/media-bridge-lib/static-1.19360",
      "fix-webm-duration": "/fix-webm-duration/static-1.27",
      "notification-sounds": "/notification-sounds/static-1.4690",
      "seat-types-lib": "/seat-types-lib/static-1.658",
      "ui-addon-opt": "/ui-addon-opt/static-4.8629",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6564",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5345",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3794",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19562",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9346",
      "reactive-lib": "/reactive-lib/static-1.985",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37911",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40141",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13229",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55614",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22130",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18742",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72771",
      "data-agent-utils": "/data-agent-utils/static-1.297",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10110",
      "utility-belt": "/utility-belt/static-1.2799",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23740",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7949",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6221",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15494",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5372",
      "qrcode-generator": "/qrcode-generator/static-1.73",
      "reporting-client-types": "/reporting-client-types/static-1.2658",
      "react-flip-move": "/react-flip-move/static-1.75",
      "FireAlarmUi": "/FireAlarmUi/static-1.4695",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4361",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11361",
      "association-settings-lib": "/association-settings-lib/static-1.10949",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58650",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.148",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.13059",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13322",
      "ExportDialog": "/ExportDialog/static-6.10643",
      "final-form": "/final-form/static-1.75",
      "nudge-client-utils": "/nudge-client-utils/static-1.3100",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7374",
      "property-management-iframe": "/property-management-iframe/static-1.14055",
      "property-usages-lib": "/property-usages-lib/static-1.5755",
      "reactflow": "/reactflow/static-1.68",
      "simple-data-table": "/simple-data-table/static-1.3473",
      "used-in-list-lib": "/used-in-list-lib/static-1.7229",
      "visual-association": "/visual-association/static-1.6156",
      "highcharts": "/highcharts/static-8.108",
      "reporting-visualizations": "/reporting-visualizations/static-1.60754",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4183",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.396",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1179",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.968",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.66",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.412",
      "slack-ui-library": "/slack-ui-library/static-1.10663",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2661",
      "ContentData": "/ContentData/static-1.69140",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1244",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.2075",
      "ai-rendering-library": "/ai-rendering-library/static-1.11039",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8277",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16332",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1383",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1553",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.560",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7132",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4179",
      "ui-tool-access": "/ui-tool-access/static-1.10418",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2445",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2661",
      "user-context-client": "/user-context-client/static-1.4775",
      "nest": "/nest/static-1.501",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36733",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16303",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4774",
      "storybook-react": "/storybook-react/static-1.37",
      "academy-common-lib": "/academy-common-lib/static-1.14892",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40977",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7490",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55630",
      "commerce-products-api": "/commerce-products-api/static-1.2652",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57688",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103449",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81492",
      "one-click-checkout": "/one-click-checkout/static-1.331",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7868",
      "reporting-ui-components": "/reporting-ui-components/static-2.65949",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15218",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19178",
      "stripe-connect-js": "/stripe-connect-js/static-1.75",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9803",
      "hub-http-contrib": "/hub-http-contrib/static-1.3304",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5478",
      "nested-table": "/nested-table/static-1.498",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22753",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3447",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.166",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2857",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3176",
      "whisper-core-api": "/whisper-core-api/static-1.7267",
      "property-management-common": "/property-management-common/static-1.6343",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15532",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12410",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34781",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.656",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.41953",
      "reporting-snowflake": "/reporting-snowflake/static-1.57296",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.473",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7873",
      "academy-service-client": "/academy-service-client/static-1.3954",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4669",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7584",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.802",
      "price-books-api": "/price-books-api/static-1.1674",
      "price-books-components": "/price-books-components/static-1.1732",
      "property-description-translator": "/property-description-translator/static-1.4106",
      "ramp-editor": "/ramp-editor/static-1.837",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3782",
      "totals-ui-components": "/totals-ui-components/static-1.24237",
      "checkout-sdk": "/checkout-sdk/static-3.24269",
      "payment-method-components": "/payment-method-components/static-1.7113",
      "touchless-buying-components": "/touchless-buying-components/static-1.6137",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3747",
      "reporting-plugins": "/reporting-plugins/static-1.10693",
      "reporting-reports": "/reporting-reports/static-1.68356",
      "edison-service-client-types": "/edison-service-client-types/static-1.657",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10768",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18053",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20646",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8290",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.426",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15531",
      "simple-menus-lib": "/simple-menus-lib/static-1.17048",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.845",
      "dashboard-lib": "/dashboard-lib/static-1.82702",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8970",
      "line-items-api": "/line-items-api/static-1.1053",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4007",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.836",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4255",
      "company-details-components": "/company-details-components/static-1.6467",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15607",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3721",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10060",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3468",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5594",
      "apps-service-types": "/apps-service-types/static-1.4006",
      "oauth-service-types": "/oauth-service-types/static-1.4507",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.933",
      "redux-actions": "/redux-actions/static-3.68",
      "company-details-service-types": "/company-details-service-types/static-1.4203",
      "pricing-pages-api": "/pricing-pages-api/static-1.15472"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30477",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};